module.exports = __webpack_public_path__ + "img/concrete-hole-decal-29.386381ef.png";